import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./assets/styles/main.css";

import Loading from "./components/Loading";
const HomePage = lazy(() => import("./pages/HomePage"));
const SignUp = lazy(() => import("./pages/SignUp"));
const SignIn = lazy(() => import("./pages/SignIn"));
const TablePage = lazy(() => import("./pages/TablePage"));
const NewsPage = lazy(() => import("./pages/NewsPage"));
const NewsDetail = lazy(() => import("./pages/NewsDetail"));
const AnnouncementsPage = lazy(() => import("./pages/AnnouncementsPage"));
const AnnouncementsDetail = lazy(() => import("./pages/AnnouncementsDetail"));
const ForgotPassword = lazy(() =>
  import("./pages/ForgotPassword/ForgotPassword")
);
const ResetPassword = lazy(() =>
  import("./pages/ResetPassword/ResetPassword")
);

const Footer = lazy(() => import("./components/Footer"));

function App() {
  return (
    <Suspense fallback={<Loading />}>
      <div className="App bg-gray-100 font-sans">
        <Router>
          <Switch>
            <Route path="/signup" component={SignUp} />
            <Route path="/signin" component={SignIn} />
            <Route path="/forgot-password" component={ForgotPassword} />
            <Route path="/reset-password" component={ResetPassword} />
            <Route path="/table" component={TablePage} />
            <Route path="/news/:slug" component={NewsDetail} />
            <Route path="/news" component={NewsPage} />
            <Route path="/announcement/:slug" component={AnnouncementsDetail} />
            <Route path="/announcement" component={AnnouncementsPage} />
            <Route path="/" component={HomePage} />
          </Switch>
        </Router>
        <Footer />
      </div>
    </Suspense>
  );
}

export default App;
